import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8.25 5.235a.75.75 0 0 1 .75.75v13.5a.75.75 0 1 1-1.5 0v-13.5a.75.75 0 0 1 .75-.75m7.5 0a.75.75 0 0 1 .75.75v13.5a.75.75 0 1 1-1.5 0v-13.5a.75.75 0 0 1 .75-.75"
}));
const ForwardRef = forwardRef(SvgComponent);
export const PauseIcon = ForwardRef;